import {
  Page,
  SkeletonView,
  Stack,
  View,
} from "@towersystems/roam-common-native";
import { Spacings } from "react-native-ui-lib";
import { FlatListSearchableSkeleton } from "../../../../../../components/FlatListSearchableSkeleton";

export interface StockCountScreenSkeletonProps {}

export const StockCountScreenSkeleton = (
  props: StockCountScreenSkeletonProps
) => {
  const headerSkeletonProps = {
    textVariant: "heading4" as const,
    style: { width: 100 },
  };

  return (
    <Page>
      <Stack vertical spacing={Spacings.s5}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: Spacings.s4,
          }}
        >
          <SkeletonView {...headerSkeletonProps} />
          <SkeletonView {...headerSkeletonProps} />
        </View>
        <FlatListSearchableSkeleton searchbar={false} rows={7} />
      </Stack>
    </Page>
  );
};
